import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

export const AiPresetQuestions = ({ onSelect, isFullscreen }) => {
    const { t } = useTranslation();
    const presetQuestions = useMemo(
        () => [
            {
                subtitle: t('Which shipments were sent earlier than expected this month?'),
                title: t('Advance shipments'),
                id: 'advance-shipments',
                emoji: '🚚',
            },
            {
                subtitle: t('What are my 10 most shipped items over the last 20 days?'),
                title: t('Top references'),
                id: 'top-references',
                emoji: '📦',
            },
            {
                subtitle: t('What is the ratio of incidents to the number of shipments this quarter?'),
                title: t('Incident rate'),
                id: 'incident-rate',
                emoji: '⚠️',
            },
        ],
        [t]
    );

    return (
        <div className={clsx('grid gap-2.5 transition-all duration-200', isFullscreen ? 'grid-cols-3' : 'grid-cols-1')}>
            {presetQuestions.map((question) => (
                <button
                    key={question.id}
                    type='button'
                    className={clsx(
                        'group flex gap-3 rounded-[14px] border border-gray-200 bg-white px-3.5 py-3 text-left transition-all duration-200 hover:-translate-y-px hover:border-lime-300 hover:bg-lime-50/60',
                        isFullscreen ? 'flex-col-reverse' : 'items-center'
                    )}
                >
                    <div
                        className={clsx(
                            'flex-1 text-[13px] leading-[1.45] text-gray-800 transition-all duration-200',
                            isFullscreen ? '!text-gray-500 text-xs' : ''
                        )}
                    >
                        {question.subtitle}
                    </div>
                    <div
                        className={clsx(
                            'flex items-center gap-2 justify-between transition-all duration-200',
                            isFullscreen ? 'w-full' : ''
                        )}
                    >
                        {isFullscreen && (
                            <div className='flex items-center gap-2'>
                                <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-gray-200 bg-gray-50 text-base'>
                                    {question.emoji}
                                </div>
                                <span className='text-sm font-semibold text-gray-900'>{question.title}</span>
                            </div>
                        )}
                        <button
                            type='button'
                            onClick={() => onSelect(question.subtitle)}
                            className='flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-lime-300 hover:bg-lime-400 active:bg-lime-500 cursor-pointer'
                        >
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                    </div>
                </button>
            ))}
        </div>
    );
};
